import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropertyCard from './PropertyCard';
import api from '../../api/axiosConfig';

export default function RelatedProperties({ 
  propertyId, 
  onPropertyClick, 
  fxRates, 
  userCurrency,
  limit = 6 
}) {
  const { t } = useTranslation('PropertyModal');
  const [relatedProperties, setRelatedProperties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRelatedProperties = useCallback(async (id) => {
    if (!id) return;
    
    setLoading(true);
    setError(null);
    
    try {
      // Try feature-based recommendations first
      const response = await api.get(`/interactions/feature-recommendations/?property_id=${id}&limit=${limit}`);
      
      if (response.data.recommendations && response.data.recommendations.length > 0) {
        setRelatedProperties(response.data.recommendations);
      } else {
        // Fallback to standard related properties
        const fallback = await api.get(`/properties/${id}/related/?limit=${limit}`);
        setRelatedProperties(fallback.data);
      }
    } catch (err) {
      console.error('Failed to fetch related properties:', err);
      
      // Final fallback to standard recommendations
      try {
        const fallback = await api.get(`/properties/${id}/related/?limit=${limit}`);
        setRelatedProperties(fallback.data);
      } catch (fallbackErr) {
        setError(fallbackErr.message);
      }
    } finally {
      setLoading(false);
    }
  }, [limit]);



  useEffect(() => {
    fetchRelatedProperties(propertyId);
  }, [propertyId, fetchRelatedProperties]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-pink-500"></div>
      </div>
    );
  }

  if (error || relatedProperties.length === 0) {
    return null;
  }

  return (
    <div className="py-8 bg-[var(--bg-black)]">
      <h2 className="text-xl font-bold text-[var(--text-black)] mb-6 px-4">
        {t('propertyModal.relatedProperties', 'More Like This')}
      </h2>
      
      <div className="overflow-x-auto px-4 scrollbar-hide">
        <div className="flex gap-4 pb-4">
          {relatedProperties.map((property) => (
            <div
              key={property.id}
              className="flex-shrink-0 w-72"
              onClick={() => onPropertyClick?.(property.id)}
            >
              <PropertyCard
                property={property}
                isActive={true}
                isScrolling={false}
                onImageLoad={() => {}}
                className="h-96"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}